import { useRef, useLayoutEffect } from "react";
import { Box } from "@mui/material";

export function SecondaryHeaderHtmlContent(props: {
  contentHtml: string | undefined;
}) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useLayoutEffect(() => {
    if (!iframeRef.current || !props.contentHtml) return;

    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument;
    if (!iframeDoc) return;

    const market1 =
      "https://www.content.shi.com/SHIcom/Core/Production/css/SHI-Styles.P25.2.9.css";
    const market2 =
      "https://www.content.shi.com/cms-content/accelerator/media/stylesheets/shi-marketing-min-12.css";

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="utf-8">
          <base target="_top">
          <link href="${market1}" rel="stylesheet" crossorigin="anonymous">
          <link href="${market2}" rel="stylesheet"  crossorigin="anonymous">
        </head>
       <style>
        body {
          padding-left: 24px;
          padding-right: 24px;
          overflow: hidden;
          box-sizing: border-box;
        }
      </style>
        <body>
          ${props.contentHtml}
        </body>
      </html>
    `;

    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();

    const syncHeight = () => {
      if (!iframe.contentDocument?.body) return;
      iframe.style.height = `${iframe.contentDocument.body.scrollHeight}px`;
    };

    const observer = new ResizeObserver(syncHeight);
    observer.observe(iframeDoc.body);

    syncHeight();

    return () => {
      observer.disconnect();
    };
  }, [props.contentHtml]);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        padding: 0,
        backgroundColor: "#fff",
      }}
    >
      {props.contentHtml ? (
        <iframe
          ref={iframeRef}
          title="Navigation content"
          style={{
            width: "100%",
            border: "none",
            display: "block",
          }}
          sandbox="allow-same-origin allow-top-navigation-by-user-activation"
        />
      ) : null}
    </Box>
  );
}

